<template>
    <div class="excellentClassroom">
        <!--查看知识点精讲-->
        <div >
            <div class="commonBackground topHeader">
                <div class="sonHeader border-bottom padding-b">
                    <div>
                        <span>学科:</span>
                        <span :class="subjectId===item.subjectId?'select':''"
                              @click="selectSubject(item.subjectId,item.subjectName)"
                              class="cursorSz"
                              v-for="item in subjectList" :key="item.subjectId">
                        {{item.subjectName}}
                    </span>
                    </div>
                    <div>
                        <span>分类:</span>
                        <span class="cursorSz"
                              :class="typeId===item.id?'select':''"
                              :title="item.title" v-for="(item,index) in typeAVersion"
                              @click="selectCategory(item.id)" :key="index">
                    {{item.title}}</span>
                    </div>
                    <div>
                        <span>版本:</span>
                        <span @click="selectVersion(item.id)"
                              :title="item.title"
                              class="cursorSz"
                              :class="versionId===item.id?'select':''"
                              v-for="(item,index) in versionList"
                              :key="index">
                    {{item.title}}
                    </span>
                    </div>
                </div>

                <div class="tagBoxOption">
                    <span class="display-b-i cursorSz tagBlock" v-for="(item,index) in tagList"
                          :key="item.tagId" @click="selectTag(item.tagId)"
                          :class="tagId===item.tagId?'selectBorder':''">
                        {{item.tagName}}
                    </span>
                </div>
            </div>
            <div>
                <div class="sortRule padding-y">
                    <span v-for="(item,index) in videoRule"
                          @click="selectOrderBy(item.orderBy)"
                          class="orderBlock "
                          :key="item.orderBy"
                          :class="orderBy===item.orderBy?'selectText':''">
                        <span class="cursorSz">
                            {{item.text}}
                        </span>
                         <span class="m-s-x text-default-color"
                               v-show="index<=videoRule.length-2">|</span>
                    </span>
                </div>
            </div>
        </div>
        <!--左侧栏-->
        <div class="knowledgeTree commonShadow position-relative"
             :class="changeGd?'gd':''">
            <div v-show="!loadingTj">
                 <!--左侧目录-->
                <div class="padding-small">
                    <div class="elTreeBox public_scroll_bar">
                        <el-tree
                                class="margin-top"
                                :data="unitList"
                                default-expand-all
                                node-key="id"
                                ref="tree"
                                :highlight-current=true
                                :props="defaultProps">
                            <!--嵌套其中的值，scope的data可以获得当前节点的值，这样写实现嵌套效果-->
                            <div slot-scope="{node,data}" style="width: 180px;">
                                <div   @click="selectUnit(data.id)" :class="unitId===data.id?'directoryActive':''" style="padding:5px;" :style="node.level===1?'font-weight:bolder;font-size:1.1em;':''" class=" text-ellipsis" :title="data.title"  >
                                    {{data.title}}
                                </div>
                            </div>
                        </el-tree>
                    </div>
                </div>
            </div>
            <loading :show="loadingTj"  >
            </loading>
        </div>
        <div class="float-left rightContent"  :class="changeGd?'gdrC':''">
            <div>
                <div class="  albumBox position-relative"  >
                    <div v-show="albumList.length>0&&!loadingData">
                        <div class="albumBoxSon">
                            <div class="float-left albumBlock commonBackground" v-for="(item,index) in albumList" :key="index">
                                <div @click="jumpPlayVideo(item.albumId)" class="imgBox cursorSz">
                                    <img src="" v-lazy="item.coverImg" :key="item.coverImg" alt=""/>
                                </div>
                                <div class="content">
                                    <div class="text-ellipsis text-default-color name"
                                         style="font-size: 14px; "
                                         :title="item.name">
                                        <div class="item_tag type1 vertical-middle" style="background: #2E86FF;" v-if="item.hardLevel==1">基础</div>
                                        <div class="item_tag type1 vertical-middle" style="background: #FF8C00;" v-if="item.hardLevel==2">提高</div>
                                        <div class="item_tag type1 vertical-middle" style="background: #FA6D88;" v-if="item.hardLevel==3">拔尖</div>
                                        <span class=" nameSon  ">
                                            {{item.name}}
                                        </span>
                                    </div>
                                    <div class="bottom delFloat" style="font-size: 12px;margin-top: 5px">
                                        <div class="text-l-secondary float-left">
                                            {{item.createdAt}}
                                        </div>
                                        <div class="float-right" >
                                            {{item.teacherName}}
                                        </div>
                                    </div>
                                    <div class="playCount bj delFloat">
                                        <div class="border-right text-center">
                                            <span class="el-icon-view eIcon"></span> {{item.playTimes}}
                                        </div>
                                        <div class="text-center">
                                            <span class="el-icon-star-off eIcon"></span> {{item.score}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center margin-bottom">
                            <el-pagination
                                    class="margin-top"
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="currentPage"
                                    :page-size="12"
                                    layout="prev, pager, next, jumper"
                                    :total="totalItem">
                            </el-pagination>
                        </div>
                    </div>
                    <empty v-show="albumList.length<1&&!loadingData" class="margin-medium-top">
                    </empty>
                    <loading :show="loadingData" ></loading>
                </div>
            </div>
        </div>
        <common-target-router @clearHref="clearHref" :get-location="getLocation"></common-target-router>
    </div>
</template>
<script>
    import {studyAlbum, studyCategory, studyChapter, studyOrderByStr, studySubjects, studyTags} from "../../config";
    export default {
        name: "excellentClassroom",
        data(){
            return{
                getLocation:'',
                changeGd:false,
                defaultProps: {children: 'children',label: 'title'},
                subjectList:[],
                subjectId:'',
                subjectName:'',
                //条件加载
                loadingTj:false,
                //分类及版本
                typeAVersion:[],
                typeId:'',
                //版本list
                versionList:[],
                versionId:'',
                versionName:'',
                unitList:[],
                unitId:'',
                //课程定位标签list
                tagList:[],
                tagId:'',
                albumList:[],
                currentPage:1,
                totalItem:0,
                loadingData:true,
                //接收视频规则列表
                videoRule:[],
                //获取所选择的视频规则
                orderBy:''
            }
        },
        mounted(){
          this.searchSubjects();
          this.videoTopGz();
          window.onscroll=(()=>{
              if(window.pageYOffset>=275){
                  this.changeGd=true;
              }else{
                  this.changeGd=false;
              }
          })
        },
        methods:{
            selectOrderBy(val){
                this.currentPage=1;
                this.orderBy=val;
                this.searchAlbum();
            },
            clearHref(){
              this.getLocation='';
            },
            jumpPlayVideo(val){
                const {href} = this.$router.resolve(
                    {path:'/videoPlayer',
                        query:{albumId:val,type:''}}
                );
                this.getLocation=href;
            },
            //分页选项
            handleCurrentChange(){
                this.searchAlbum();
            },



            //查出学科
            async searchSubjects(){
                this.loadingTj=true;
                let result=await studySubjects();
                if(result.status){
                    this.subjectList=result.data;
                    this.subjectId=result.data[0].subjectId;
                    this.subjectName=result.data[0].subjectName;
                    this.searchCategoryAVersion();
                }else{
                    this.loadingTj=false;
                }
            },
            //查出分类
            async searchCategoryAVersion(){
                let result=await studyCategory(this.subjectId);
                if(result.status){
                    this.typeAVersion=result.data;
                    this.typeId=result.data[0].id;
                    this.versionList = result.data[0].children;
                    this.versionId=result.data[0].children[0].id;
                    this.versionName=result.data[0].children[0].title;
                    this.searchUnitChapter();
                }else{
                    this.loadingTj=false;

                }
            },
            //根据版本id查出单元章节
            async searchUnitChapter(){
                let result=await studyChapter(this.versionId);
                if(result.status){
                    this.loadingTj=false;
                    this.unitList=result.data;
                    this.unitId=result.data[0].id;
                    this.searchCurriculum();
                }else{
                    this.loadingTj=false;
                }
            },
            //选择学科
            selectSubject(valId,valName){
              this.currentPage=1;
              this.subjectName =valName;
              this.subjectId=valId;
              this.searchCategoryAVersion();
            },
            //选择教材
            selectCategory(val){
                this.currentPage=1;
                this.typeId=val;
                let zhi=this.typeAVersion.filter((valSmall)=>{
                    return val===valSmall.id;
                })
                this.versionList=zhi[0].children;
                this.versionName=zhi[0].children[0].title;
                this.versionId=zhi[0].children[0].id;
                this.searchUnitChapter();
            },
            //选择版本
            selectVersion(val){
                this.versionId=val;
                this.currentPage=1;
                this.searchUnitChapter();
            },
            //选择章节
            async selectUnit(val){
                this.currentPage=1;
                this.unitId=val;
               this.searchCurriculum();
            },
            //查出当前章节下的课程定位标签
            async searchCurriculum(){
                let result =await studyTags(this.unitId);
                if(result.status){
                    this.tagList=result.data;
                    this.tagId=result.data[0].tagId;
                    this.searchAlbum();
                }else{

                }
            },
            //选择标签
            selectTag(val){
                this.currentPage=1;
                this.tagId=val;
                this.searchAlbum();
            },
            //根据左侧目录查出右侧视频专辑
            async searchAlbum(){
                this.loadingData=true;
                let result=await studyAlbum(this.unitId,this.tagId,this.orderBy,this.currentPage,12);
                if(result.status){
                    this.loadingData=false;
                    this.albumList=result.data.data;
                    this.totalItem=result.data.totalRecords;
                }else{
                    this.loadingData=false;
                }
            },
            //查出视频上方的排序规则
            async videoTopGz(){
                let result=await studyOrderByStr();
                if(result.status){
                    this.videoRule=result.data;

                }else{

                }
            }
        }
    }
</script>
<style lang="scss">
    .excellentClassroom{
        .versionBox:after{
                content: ".";
                display: block;
                height: 0;
                clear: both;
                visibility: hidden;
        }
        .versionBlock{
            width:160px;
            height:41px;
            line-height: 40px;
            border: 1px solid #EEEFF3;

            text-align: center;
            margin-right: 20px;
            margin-bottom: 20px;
            color: #6B7884;
            font-size: 16px;
            cursor: pointer;
            font-weight: 400;
        }
        .versionBlock:last-child{
            margin-right: 0;
        }

        .versionBlock:hover{
            animation: commonOption .4s ease-out forwards;
        }
    }
</style>
<style lang="scss" scoped>
    .excellentClassroom{
        margin:10px auto 0 auto;
        .topHeader{
            padding:5px 20px 20px 20px;
            div{
                >span{
                    display: inline-block;
                    margin-top: 16px;
                    margin-right:15px;
                    padding:5px 10px;

                }

                >span:nth-of-type(1){
                    padding:0;
                    font-weight: bold;
                }
                .tagBlock{
                    padding:5px 10px!important;
                }
            }
        }
        .knowledgeTree.gd{

             position: fixed;
             top:65px;
         }
        .selectOrderBy{
            color:#0a93fc;
        }
        .knowledgeTree {
            background: #ffffff;
            width: 280px;
            height: calc(100vh - 376px);
            float: left;
            margin-right: 10px;
            .el-button {
                width: 280px;

            }
            .elTreeBox{
                height: calc(100vh - 392px);
                overflow-y: auto;
            }
            .category{
                text-align: center;
                height: 30px;
                line-height: 30px;
                font-size: 15px;
                margin: 10px 0 10px 0;

                .xiaox{
                    border-radius: 5px;
                    padding: 0 8px 0 8px;
                    cursor: pointer;
                    width: 77px;
                    margin-right: 16px;
                }
                .xiaox:last-child{
                    margin-right: 0;
                }
                div:hover{
                    animation: commonOption .4s ease-out forwards;
                }
            }
            .version{
                padding: 10px;
                font-size: 1.2em;
                height:40px;
                .versionMenu{
                    transform: rotate(90deg);
                    font-size: 18px;
                }
            }
        }
        .rightContent.gdrC{
            margin-left: 290px!important;
        }
        .rightContent{
            width: calc(100vw - 347px);
            min-height: 500px;
            .tagBox{
                background: #ffffff;
                padding: 10px 0 10px 10px;
                border-radius: 9px;
                min-width: 980px;
                .tagTitle{
                    margin-top: 5px;
                }
                .tagBlock:hover{
                    animation: commonOption .4s ease-out forwards;
                }
                .tagBoxOption{

                    float: left;
                }
                .tagBlock{
                    margin:0 10px 0 0;
                    width:72px;
                    padding: 5px;
                    cursor: pointer;
                    text-align: center;
                }
            }
            .tagBox.gud{
                z-index:2;
                position:fixed;
                top:60px;
            }
            .tagBox:after{
                content: ".";
                display: block;
                height: 0;
                clear: both;
                visibility: hidden;
            }
            .albumBox{
                height:auto;
                min-height: calc(100vh - 153px);
                .sortRule{
                    height:30px;
                    line-height: 40px;
                }
                .orderBlock{
                    margin-right: 10px;
                    cursor: pointer;
                }
                .albumBoxSon:after{
                    content: ".";
                    display: block;
                    height: 0;
                    clear: both;
                    visibility: hidden;
                }
                .albumBlock{
                    width:310px;
                    margin:0 16px 20px 0;
                    border-radius: 2px 2px 2px 2px;
                    img{
                        width:100%;
                        height:176px;
                        border-radius: 2px 2px 0px 0px;
                    }
                    .content{
                        padding:6px 5px 0 5px;
                        .name{

                            .nameSon{
                                font-size:15px;
                                color: rgba(27, 28, 50, 0.85);
                            }
                        }
                        .bottom{
                            margin-top:3px;
                            .time{
                                float: left;


                            }
                            .playCount{
                                float: right;
                                .eIcon{
                                    margin-right: 2px;
                                }
                            }
                        }
                        .bottom:after{
                            content: ".";
                            display: block;
                            height: 0;
                            clear: both;
                            visibility: hidden;
                        }
                        .bj{
                            margin-top: 7px;
                            font-size: 14px;
                            border-top:1px dashed #e5e5e5;
                            color: rgba(27, 28, 50, 0.45);
                            padding:5px 0;
                            >div{
                                width:50%;
                                float: left;
                            }
                        }
                        .teacherName{
                            color: #989898;
                        }
                    }
                }
                .albumBlock:hover{
                    animation: commOptionBox .4s ease-out forwards;
                }

                .item_tag{
                    padding: 1px 2px;
                    border-radius: 2px;
                    font-size: 12px;
                    float: left;
                    color: #fff;
                    margin-right: 5px;
                }
            }
        }
    }
</style>
